import repositories from '..';

const resource = '/integration/api-groups';

export default {
  getInitData: () => repositories.get(`${resource}/data/init`),
};
